<unity-page-container
  [contentHeader]="$contentHeader()"
  [contentHeaderSecondary]="$contentHeaderSecondary()"
  [contentHeaderTertiary]="$contentHeaderTertiary()"
  [isLoading]="false">
  <ng-container page-return>
    <unity-action-shared [action]="$returnToAgreementAction()" />
  </ng-container>

  <ng-container notifications />

  <ng-container actions>
    <unity-action-shared [action]="$createClientExpenseAction()" />
    <unity-workflow-selector-shared
      [transitions]="$transitionsThatDoNotRequireValidation()"
      [disabled]="$isEditing()"
      (workflowEvent)="onWorkflow($event)" />
    <unity-action-delete-shared
      *unityAuthorize="deleteEntitlement"
      buttonText="Delete Client"
      confirmationTitle="Confirm Delete Client?"
      confirmationMessage="Are you sure you want to delete this Client?"
      [disabled]="$isEditing()"
      (deleteEvent)="onDelete()" />
  </ng-container>

  <ng-container stats>
    <unity-card-client-agreement-duration-summary-shared [client]="$resource()" [isLoading]="$isLoading()" />
    <unity-card-client-budget-summary-shared [client]="$resource()" [isLoading]="$isLoading()" />
  </ng-container>

  @let formSchema = $formSchema();
  @let transitionsThatRequireValidation = $transitionsThatRequireValidation();
  @let surveyModel = $surveyModel();

  @if (formSchema && surveyModel) {
    <unity-card-manage-survey-shared
      headerMeta="Client Details"
      [resource]="$resource()"
      [isEditable]="$isEntitledToEdit()"
      [isEditing]="$isEditing()"
      [isSaving]="$isSaving()"
      [surveyModel]="surveyModel"
      [transitions]="transitionsThatRequireValidation"
      (saveEvent)="onSave($event)"
      (editEvent)="onEdit()"
      (cancelEvent)="onCancel()" />
  }
  <unity-grid-client-expense-shared gridTitle="Client Expenses" [agreementId]="$agreementId()" [clientId]="$clientId()" />
</unity-page-container>
